import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoutes";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Login from "../Pages/Auth/Login/Login";
import Massage from "../Pages/Massege/Massage";
import PushNotification from "../Pages/PushNotification/PushNotification";
import Settings from "../Pages/Settings/Settings";
import PartnerAd from "../Pages/Advertisment/PartnerAd/PartnerAd";
import CreateMassage from "../Pages/Massege/CreateMassage/CreateMassage";
import Chat from "../Pages/Massege/Chat/Chat";
import Profile from "../Pages/Profile/Profile";
import EditProfile from "../Pages/Profile/EditProfile/EditProfile";
import Notification from "../Pages/notification/notification";
import ViewAdStats from "../Pages/Advertisment/PartnerAd/ViewStats/ViewAdStats";
import ViewNotificationDetails from "../Pages/PushNotification/viewNotification/viewDetails";


const Router = () => {
  const token = getTokenFromCookie();
  const navigate = useNavigate()
  const location = useLocation();


  function getTokenFromCookie() {
    const cookieString = document.cookie;
    const cookies = cookieString.split(";");

    for (const cookie of cookies) {
      const [name, value] = cookie.split("=").map((c) => c.trim());
      if (name === "token") {
        return value;
      }
    }

    return null; // Return null if the token cookie is not found
  }
  // useEffect(() => {
  //   // Check if token exists
  //   if (token && location.pathname === "/login") {
  //     // Redirect user to the desired route
  //     navigate("/");
  //   }
  // }, [location.pathname, token, navigate])

  const routes = [
    { path: "/", element: <PrivateRoute> <Dashboard /></PrivateRoute> },
    { path: "/Messages", element: <PrivateRoute><Massage /></PrivateRoute> },
    { path: "/CreateMessages", element: <PrivateRoute><CreateMassage /></PrivateRoute> },
    { path: "/Messages/Chat/:id", element: <PrivateRoute><Chat /></PrivateRoute> },
    { path: "/Notification", element: <PrivateRoute><PushNotification /></PrivateRoute> },
    { path: "/Settings", element: <PrivateRoute><Settings /></PrivateRoute> },
    { path: "/Partner", element: <PrivateRoute><PartnerAd /></PrivateRoute> },
    { path: "/Profile", element: <PrivateRoute><Profile /></PrivateRoute> },
    { path: "/EditProfile", element: <PrivateRoute><EditProfile /></PrivateRoute> },
    { path: "/notificationdata", element: <PrivateRoute><Notification /></PrivateRoute> },
    { path: "/Notification/viewNotification/:id", element: <PrivateRoute><ViewNotificationDetails /></PrivateRoute> },
    { path: "/viewstats/:id", element: <PrivateRoute><ViewAdStats /></PrivateRoute> },
    { path: "/login", element: <Login /> },
  ];

  return (
    <Routes>
      {routes.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
};

export default Router;
